define('home/templates/channelModeratorUser',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "<span class=\"label--default -inline\">"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Creator",{"name":"gettext","hash":{},"data":data}))
    + "</span>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "<div class=\"user-card__button\">\n<button class=\"button button-outline button-small\" data-action=\"remove-moderator\">\n"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Remove",{"name":"gettext","hash":{},"data":data}))
    + "\n</button>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<div class=\"card--user\">\n<div class=\"user-card__block\">\n"
    + ((stack1 = container.invokePartial(partials.userAvatar,depth0,{"name":"userAvatar","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(partials.userName,depth0,{"name":"userName","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isChannelOwner : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.isChannelOwner : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true})

});
